import { ReactNode } from 'react';

export interface StepItem {
  icon: ReactNode;
  title: string;
  description: string;
}

interface StepListProps {
  steps: StepItem[];
}

export const StepList = ({ steps }: StepListProps) => {
  return (
    <div className="my-4 space-y-2 text-left">
      {steps.map((step, index) => (
        <div key={`${step.title}-${index}`} className="flex items-start rounded-lg border border-gray-200 bg-white p-3">
          <div className="mr-3 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600">
            {step.icon}
          </div>
          <div>
            <h4 className="text-sm font-medium text-gray-900">{`${index + 1}. ${step.title}`}</h4>
            <p className="mt-1 text-xs text-gray-600">{step.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
